
import { PropType } from 'vue';
import PromoBox from '@/interfaces/promoBox.interface';

export default {
    props: {
        promoBox: {
            type: Object as PropType<PromoBox>,
            default: () => ({
                backgroundColor: '',
                bodyText: '',
                ctaButton: {
                    ctaType: '',
                    gaAction: '',
                    gaCategory: '',
                    gaIndgangsmetode: '',
                    gaLabel: '',
                    icon: {
                        name: '',
                    },
                    lineBreak: false,
                    link: {
                        name: '',
                        target: '',
                        url: '',
                    },
                },
                heading: '',
                illustration: {
                    altText: '',
                    center: [],
                    id: 0,
                    mediaCrops: [],
                    name: '',
                    relativeUrl: '',
                    umbracoHeight: '',
                    umbracoWidth: '',
                    url: '',
                },
                isClickable: true,
            }),
        },
    },

    computed: {
        convertedBodyText(): string {
            return this.promoBox.bodyText
                ? this.promoBox.bodyText.replace('\n', '<br>')
                : '';
        },
        illustrationSrc(): string {
            return `${this.promoBox.illustration?.url}?height=240`;
        },
        /**
         * Check if the component should display the button
         *
         * @return {boolean}
         */
        showButton(): boolean {
            return (
                this.promoBox.ctaButton !== undefined &&
                this.promoBox.ctaButton?.link !== undefined &&
                this.promoBox.ctaButton?.link?.url !== ''
            );
        },
        /**
         * Check if the component has an icon.
         *
         * @return {boolean}
         */
        hasIcon(): boolean {
            return this.promoBox.ctaButton?.icon !== undefined;
        },

        /**
         * Define modifier class.
         *
         * @return {string}
         */
        buttonTheme(): string {
            if (this.promoBox.ctaButton?.ctaType === 'Sekundær knap') {
                return 'outlined';
            }
            return '';
        },
        /**
         * Define modifier class.
         *
         * @return {string}
         */
        buttonIcon(): string {
            if (
                this.promoBox.ctaButton &&
                this.promoBox.ctaButton.icon?.name !== undefined &&
                this.promoBox.ctaButton.icon?.name !== null
            ) {
                return this.promoBox.ctaButton.icon?.name ?? '';
            }
            return '';
        },
        /**
         * Define modifier class.
         *
         * @return {string}
         */
        buttonUrl(): string {
            if (
                this.promoBox.ctaButton &&
                this.promoBox.ctaButton.link !== undefined &&
                this.promoBox.ctaButton.link?.url !== ''
            ) {
                return this.promoBox.ctaButton?.link?.url ?? '';
            }
            return '';
        },
        /**
         * Define modifier class.
         *
         * @return {string}
         */
        modifierClass(): string {
            const bg = `o-promoBox--${this.promoBox.backgroundColor}`;
            const isFullCta = this.promoBox.isClickable
                ? ' o-promoBox--fullCta'
                : '';
            const concatenatedModifierClass = `${bg}${isFullCta}`;
            return concatenatedModifierClass;
        },
    },
};
